import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  // Divider,
  Chip
} from '@mui/material';
import { Shield, 
  // Zap, 
  // Award, 
  // TrendingUp 
} from 'lucide-react';
import { Link } from 'react-router-dom';

const ProfessionalFooter = () => {

  // const stats = [
  //   { icon: <TrendingUp size={20} />, value: '95%', label: 'Accuracy Rate' },
  //   { icon: <Zap size={20} />, value: '2.3s', label: 'Avg Response Time' },
  //   { icon: <Award size={20} />, value: '40%', label: 'Conversion Increase' },
  //   { icon: <Shield size={20} />, value: '100%', label: 'Data Security' }
  // ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'grey.50',
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 4,
        mt: 'auto'
      }}
    >
      <Container maxWidth="xl">
        {/* Stats Section */}
        {/* <Grid container spacing={3} sx={{ mb: 4 }}>
          {stats.map((stat, index) => (
            <Grid item xs={6} md={3} key={index}>
              <Box sx={{ 
                textAlign: 'center',
                p: 2,
                borderRadius: 2,
                backgroundColor: 'white',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.08)'
                }
              }}>
                <Box sx={{ 
                  color: 'primary.main', 
                  mb: 1,
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  {stat.icon}
                </Box>
                <Typography variant="h5" fontWeight="700" color="primary">
                  {stat.value}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {stat.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ mb: 3 }} /> */}

        {/* Main Footer Content */}
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                p: 1,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white'
              }}>
                <Shield size={20} />
                <Typography variant="h6" fontWeight="700">
                  FinLead AI
                </Typography>
              </Box>
              </Link>
              <Chip
                label="Demo Version"
                size="small"
                sx={{
                  backgroundColor: 'warning.light',
                  color: 'warning.contrastText',
                  fontWeight: 600
                }}
              />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              © 2025 FinLead AI. All rights reserved.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Intelligent Commission Scoring Platform
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: { xs: 'flex-start', md: 'flex-end' }, 
              gap: 2,
              flexWrap: 'wrap'
            }}>
              <Chip
                label="AI-Powered Analytics"
                variant="outlined"
                size="small"
                sx={{ fontWeight: 500 }}
              />
              <Chip
                label="Real-time Scoring"
                variant="outlined"
                size="small"
                sx={{ fontWeight: 500 }}
              />
              <Chip
                label="Multi-Product Support"
                variant="outlined"
                size="small"
                sx={{ fontWeight: 500 }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Additional Info */}
        <Box sx={{ 
          mt: 3, 
          pt: 3, 
          borderTop: '1px solid', 
          borderColor: 'divider',
          textAlign: 'center'
        }}>
          <Typography variant="caption" color="text.secondary">
            This is a demonstration platform showcasing AI-powered commission scoring capabilities.
            Built with React, Material-UI, and advanced machine learning algorithms.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ProfessionalFooter;